import { FC } from 'react'
import { Navigate, Route, Routes } from 'react-router'
import { LoginCallback } from '@okta/okta-react'
import { PageSpinner } from '@signifyd/components'
import AppLayout from 'core/components/AppLayout/AppLayout'
import AuthRequired from 'core/components/AuthRequired/AuthRequired'
import Dashboard from 'pages/Dashboard/Dashboard'
import RunDetails from 'pages/RunDetails/RunDetails'
import CiRuns from 'pages/CiRuns/CiRuns'
import SpecFileDetails from 'pages/SpecFileDetails/SpecFileDetails'
import TraceViewer from 'pages/TraceViewer/TraceViewer'
import PerformanceMetrics from 'pages/PerformanceMetrics/PerformanceMetrics'
import Hub from 'pages/Hub/Hub'
import SignedOutPage from 'pages/SignedOutPage/SignedOutPage'

const AppRoutes: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<AuthRequired element={<AppLayout />} />}>
        <Route index element={<Hub />} />
        <Route path="/playwright" element={<Dashboard />} />
        <Route path="/playwright/:projectName/ci-runs" element={<CiRuns />} />
        <Route
          path="/playwright/:projectName/:runId"
          element={<RunDetails />}
        />
        <Route
          path="/playwright/spec-file/:projectName/:runId/:specFile"
          element={<SpecFileDetails />}
        />
        <Route path="/playwright/trace-viewer" element={<TraceViewer />} />
        <Route path="/performance" element={<PerformanceMetrics />} />
      </Route>
      <Route path="login" element={<SignedOutPage />} />
      <Route
        path="/login/callback"
        element={<LoginCallback loadingElement={<PageSpinner />} />}
      />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}

export default AppRoutes
